import React, { useState } from 'react';
import { ExistenciaSucursalNew } from './Chunks.js';
import  { useBarcode } from '@createnextapp/react-barcode';

const Getcodigo = (props) => {
	let codigo = props.producto.codigo;
	const { inputRef } = useBarcode({
		value: props.producto ? codigo : '',
		options: {
			  background: '#ffffff',
			  width : 2,
			  height : 100,
			  text : ( codigo+' $'+props.producto.precio )
		}
	})
	let url;
	if( inputRef.current){
		url = inputRef.current.src;
	}
	return <><img ref={inputRef} alt="Codigo"/><br/><a download="codigo.png" href={url} className="btn-small-2">Descargar</a></>;
}
const AddProductModal = (props) =>{
	const {
		visible,
		addProduct,
		handler,
		producto,
		errorcodigo,
		adminStock,
		blurCodigo,
		closeModalNew,
		resta
	} = props;
	const [open, setOpen] = useState(false);
	let ver = {
		'display' : 'block'
	}
	let ocultar = {
		'display' : 'none'
	}

	return(
		<div className={visible ? 'overlay show':'overlay'} style={{zIndex:'2'}}>
			<form onSubmit={addProduct} className="row content" style={{'width':'90%'}}>
				<div className="modal_header">
					<h5>Nuevo</h5>
					<span className="close-pop-up" onClick={closeModalNew}>x</span>
				</div>
				<div className="modal_body">
					<div className="xs-12 sm-12 md-6 lg-6">
						<div className="xs-12 sm-12 md-12 lg-12 text-center">
							<h3>Detalles</h3><br/>
						</div>
						<div className="xs-12 sm-12 md-12 lg-12">
							<label>
								<input type="text" onChange={handler} name="nombre" value={producto.nombre} placeholder=" "/>
								<span>Descripción</span>
							</label>
						</div>
						<div className="xs-12 sm-6 md-6 lg-6">
							<label>
								<div>
									<input 
										type="text"
										name="codigo"
										className={errorcodigo ? '': 'error-input' } 
										onChange={handler} 
										onBlur={blurCodigo}
										value={producto.codigo||''} placeholder=" "
									/>
									<span>Cód. de Prod.</span>
								</div>
								{	errorcodigo ? '' : <small className="error-full-box">El código ya existe</small> }
							</label>
						</div>
						<div className="xs-12 sm-6 md-6 lg-6">
							<label>
								<input type="text" onChange={handler} name="precio" value={producto.precio} placeholder=" "/>
								<span>Precio ($)</span>
							</label>
						</div>
						<div className="xs-12 sm-6 md-6 lg-6">
							<label>
								<input 
									min="0"
									max="5000"
									type="number"
									name="stockinv"
									placeholder=" "
									onChange={handler} 
									value={producto.stockinv||''}
								/>
								<span>Stock (Sucursal 65 Bodega)</span>
							</label>
						</div>
						<div className="xs-12 sm-12 md-6 lg-6">
							<label>
								<div className="input-text">{producto.stock||0}</div>
								<span className="fixed">Stock (Sucursal 65 Bodega)</span>
							</label>
						</div>
						<div className="xs-12 sm-12 md-12 lg-12 text-right">
							<div style={{'top':'0px','position':'relative'}}>
								{ producto.stockinv > 0 ?
									(  <div><span onClick={()=>adminStock('+')} className="btn-small-2">Agregar</span>
										<span onClick={()=>adminStock('-')} className="btn-small-2" style={{'marginLeft':'5px'}}>Restar</span></div>
									):
									(
										<div><span className="btn-small-2">Agregar</span>
										<span className="btn-small-2" style={{'marginLeft':'5px'}}>Restar</span></div>
									)
								}
							</div>
						</div>
						<div></div>
						{/* <div className="xs-12 sm-12 md-12 lg-12">
							<label>
								<input type="text" onChange={handler} name="descripcion" value={producto.descripcion||''} placeholder=" "/>
								<span>Descripcion</span>
							</label>
						</div> */}
						<div className="xs-12 sm-6 md-6 lg-6 text-center">
							<br/><h4>Código de Barras</h4>
							{  open  ? '' : 
								( producto.codigo ? <span className="btn-small-2" onClick={()=>setOpen(true)}>Generar Código</span> : '' ) 
							}
							<div style={ open ? ver : ocultar } >
								{ producto.codigo ? <Getcodigo producto={producto} show={open}></Getcodigo> : '' }
							</div>
						</div>
						<div className="xs-12 sm-6 md-6 lg-6 text-center"><br/>
							{ errorcodigo ?
								<button type="submit" className="btn btn-green">Guardar</button>
								: <span className="btn-lock-save">Guardar</span>
							}
						</div>
					</div>
					<div className="xs-12 sm-12 md-6 lg-6">
						<div className="xs-12 sm-12 md-12 lg-12">
							<h3 className="title-existencias text-center">Existencia en sucursales</h3><br/>
							<div style={{'height': '500px', 'overflow': 'scroll','margin-bottom':'20px'}}>
								<ExistenciaSucursalNew 
									sucursales={producto.sucursales}
									handler={handler}
									resta={resta}
									stock={producto.stock}
								/>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
}
export default AddProductModal;